import { render } from "./PurchaseShowView.vue?vue&type=template&id=b0843e5a&scoped=true"
import script from "./PurchaseShowView.vue?vue&type=script&lang=js"
export * from "./PurchaseShowView.vue?vue&type=script&lang=js"

import "./PurchaseShowView.vue?vue&type=style&index=0&id=b0843e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0843e5a"]])

export default __exports__